import type { FlowConfigData } from '../types/flowConfig.types'

export interface FlowConfigValidationIssue {
  level: 'error' | 'warning'
  message: string
}

/**
 * Validações leves para o editor visual (não substituem o motor de execução).
 */
export function validateFlowConfigForEditor(config: FlowConfigData): FlowConfigValidationIssue[] {
  const issues: FlowConfigValidationIssue[] = []
  const steps = config.steps || {}
  const ids = new Set(Object.keys(steps))

  if (!config.start_step?.trim()) {
    issues.push({ level: 'error', message: 'Defina uma etapa inicial (start_step).' })
  } else if (!ids.has(config.start_step)) {
    issues.push({
      level: 'error',
      message: `A etapa inicial «${config.start_step}» não existe no fluxo.`
    })
  }

  if (ids.size === 0) {
    issues.push({ level: 'error', message: 'Adicione pelo menos uma etapa ao fluxo.' })
  }

  for (const [id, step] of Object.entries(steps)) {
    const visit = (target: string | undefined | null, label: string) => {
      if (!target?.trim()) return
      if (!ids.has(target)) {
        issues.push({
          level: 'warning',
          message: `Etapa «${id}»: ${label} aponta para «${target}», que não existe.`
        })
      }
    }
    visit(step.next_step, 'Próxima etapa')
    visit(step.error_step, 'Erro')
    const cfg = step.config
    if (!cfg) continue
    if (step.type === 'conditional') {
      visit(cfg.true_step, 'Ramo verdadeiro')
      visit(cfg.false_step, 'Ramo falso')
      visit(cfg.default_step, 'Padrão')
      ;(cfg.conditions || []).forEach((c, i) => visit(c.next_step, `Condição ${i + 1}`))
    }
    if (step.type === 'dynamic_conditional' && cfg.dynamic_conditions) {
      const d = cfg.dynamic_conditions
      visit(d.base_next_step, 'Base')
      visit(d.item_next_step, 'Item')
      visit(d.default_step, 'Padrão (dinâmico)')
    }
  }

  return issues
}
